export default __webpack_public_path__ + "static/media/Dances_Dames.56fdf40e.mp3";